export { default as WorkTablesPage } from "./WorkTablesPage";
export { default as WorkTablePage } from "./WorkTablePage";
export { default as CreateWorkTablePage } from "./CreateWorkTablePage";
